<template>
  <div>
    <QuoteInfo v-if="isShowQuoteInfo" :action-buttons="actionButtons" :action-button-clicked="actionButtonClicked"
      :is-qr-enabled="isQrEnabled" />

    <!-- Edit Quote of a normal quote (Android UQConfigFragment "Update Quote - {id}"): the same Quote Details step as
         Create Universal Quote, prefilled → manual-quote/update, then the quote editor -->
    <div id="uqUpdateModal" ref="uqUpdateModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!px-3 laptop:!w-[500px] mobile:!mx-auto laptop:mx-[unset] mobile:!relative laptop:!absolute mobile:!right-[unset] laptop:!right-4 mobile:!top-[unset] laptop:!top-0 !m-0 h-full">
        <div class="modal-content select-none">
          <div class="modal-body !p-3 !pb-0 font-roboto flex flex-col">
            <FxModalHeader :title="'Update Quote - ' + (quoteDetail?.id || '')" :dismiss="false" @close="closeUpdateModal" />
            <UQConfigStep v-if="updatingQuote" :quote="quoteDetail" :consumer="updateConsumer" @back="closeUpdateModal"
              @updated="quoteUpdated" />
          </div>
        </div>
      </div>
    </div>

    <div id="exampleModal" ref="modal" class="modal fade modal-lg" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <QuoteModal :quote-summary="summary" :read-only="true" @event="CancelCallback" />
      </div>
    </div>

    <div id="exampleModal" ref="cancelQuote" class="modal fade modal-lg fxConfirm" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <CancelQuoteDialog @event="CancelCallback" />
      </div>
    </div>

    <div id="exampleModal" ref="cancelQuoteI" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <CancelQuoteDialogI @event="CancelCallback" />
      </div>
    </div>

    <div id="shareQuote" ref="shareQuote" class="modal fade" data-bs-backdrop="static" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <div class="modal-content shareModal">
          <div class="modal-body mobile:!p-2.5 tablet:!p-3 !pb-5 font-roboto">
            <div class="relative">
              <button type="button"
                class="absolute top-3 right-4 w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
                data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
                <img src="@/assets/images/modal-cross-icon.png">
              </button>
              <div class="relative rounded-lg overflow-hidden mobile:h-[70px] tablet:h-[80px]">
                <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
                <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                  <h4 class="text-[20px] m-0 font-roboto font-medium text-black-100">
                    Share Quote
                  </h4>
                </div>
              </div>
            </div>
            <div class="p-2.5">
              <p class="text-[16px] font-normal text-[#666666] text-center py-[20px] mb-0">
                Please enter the email address or phone number below to send quote
              </p>
              <div class="mb-3">
                <label for="recipient-name" class="col-form-label text-[14px] text-[#999999]">Email Address:</label>
                <input id="recipient-name" v-model="email" placeholder="Enter Email address" type="text"
                  class="form-control !text-[14px] focus:!outline-none">
              </div>
              <div class="mb-3">
                <label for="message-text" class="col-form-label text-[14px] text-[#999999]">Phone Number:</label>
                <input id="recipient-name" v-model="phone" placeholder="Enter Phone Number" type="text"
                  class="form-control !text-[14px] focus:!outline-none" @input="acceptNumber">
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 !pb-[30px] !pt-0 !justify-center">
            <div class="flex justify-center gap-2.5">
              <button
                class="px-[26px] py-[8px] rounded-[5px] text-[14px] font-roboto transition duration-300 border-[#F67280] border-1 mobile:bg-[#F67280] laptop:bg-[#fff] mobile:text-[#fff] laptop:text-[#F67280] laptop:hover:bg-[#F67280] laptop:hover:text-[#fff]"
                @click="closeModal">
                Cancel
              </button>
              <button
                class="px-[32px] py-[8px] rounded-[5px] text-[14px] font-roboto transition duration-300 border-[#00B7C2] border-1 mobile:bg-[#00B7C2] laptop:bg-[#fff] mobile:text-[#fff] laptop:text-[#00B7C2] laptop:hover:bg-[#00B7C2] laptop:hover:text-[#fff]"
                @click="onSubmit()">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isNotesOpen" id="notesModal" class="modal fade modal-md show bg-opacity-50 bg-[#000]" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="display: block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content !rounded-[20px]">
          <div class="modal-body p-4 pb-5">
            <div class="flex flex-col gap-4 w-full">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full bg-[#FE5000]" />
                  <span class="w-10 h-2 rounded-full bg-[#FE5000]" />
                  <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">
                    Internal Notes
                  </h2>
                </div>
                <button class="w-[40px] h-[40px] p-2 rounded-full bg-opacity-60 bg-[#EFEFEF]" type="button"
                  data-bs-dismiss="modal" aria-label="Close" @click="closeNotesModal">
                  <img src="@/assets/images/modal-cross-icon.png">
                </button>
              </div>
              <noteBox />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="waiveTradeCallFee" ref="waiveTradeCallFee" class="modal fade fxModal fxConfirm" data-bs-backdrop="static" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body">
          <ConfirmLayout title="Alert" button-text="Continue" @close="closeWaiveTradeCallFee()"
            @confirm="continueWaiveTradeCallFee()">
            Are you sure you want to waive your TradeCall fee?
          </ConfirmLayout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QuoteModal from "@/components/quote_modal/QuoteModal.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import { Modal } from "bootstrap";
import QuoteInfo from "@/components/quote/QuoteInfo.vue";
import CancelQuoteDialog from "@/components/tradecall_dialog/CancelQuoteDialog.vue";
import CancelQuoteDialogI from "@/components/tradecall_dialog/CancelQuoteDialog_.vue";
import noteBox from "../../components/notes/noteBox.vue";
import ConfirmLayout from "../../components/confirmDialog/ConfirmLayout.vue";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { uqApi } from "../../services/uqApi";
import FxModalHeader from "../../components/nest_components/FxModalHeader.vue";
import UQConfigStep from "../../components/quote/create/UQConfigStep.vue";

// job_source.slug → the source's detail page (Android View Appointment / View Order / View Booking)
const SOURCE_ACTIONS = {
  appointment: { title: "View Appointment", path: "/appointment/detail/" },
  "replacement-quote": { title: "View Order", path: "/replacement-quote/detail/" },
  "service-and-repair": { title: "View Booking", path: "/job/detail/" },
};


export default {
  components: {
    QuoteInfo,
    QuoteModal,
    CancelQuoteDialog,
    CancelQuoteDialogI,
    noteBox,
    ConfirmLayout,
    FxModalHeader,
    UQConfigStep,
  },

  data() {
    return {
      summary: null,
      updatingQuote: false,
      actionButtons: [],
      isShowQuoteInfo: false,
      timer: null,
      phone: "",
      email: "",
      isQrEnabled: false,
      isNotesOpen: false,
    };
  },
  computed: {
    // partner (NRG / allied) quote — same rule as QuoteInfo / TabButtons; Android isOtherUQ (partner_info status)
    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false;
    },
    // Quote Details step data for the Update Quote modal (units come from the quote source, or its address)
    updateConsumer() {
      const q = this.quoteDetail || {};
      return {
        first_name: q.consumer?.first_name || "",
        last_name: q.consumer?.last_name || "",
        address: q.address_text || "",
        address_id: q.address_id,
        source_type: q.job_source?.slug || "consumer",
        source_id: q.job_source?.id || 0,
      };
    },
    ...mapGetters([
      "quoteEmailResponse",
      "quoteDetail",
      "quoteSummary",
      "checkoutResponse",
      "cancelReasons",
      "waiveTradeCallFee",
      "resubmitQuote",
      "createInvoiceResponse"
    ]),
  },

  watch: {

    resubmitQuote: function (data) {

      if (data) {
        this.getQuoteDetail({
          manual_quote_id: this.$route.params.id,
        });
      }
    },

    waiveTradeCallFee: function (data) {

      if (data) {

        if (this.quoteDetail.is_quote_submitted) {
          // resubmit quote
          this.resubmitManualQuote({
            manual_quote_id: this.$route.params.id,
          });

        }
        else {
          this.getQuoteDetail({
            manual_quote_id: this.$route.params.id,
          });
        }

      }
    },
    quoteEmailResponse: function (data) {
      toast.success(data.message);
      this.modal.hide();
      enableScroll()
    },
    quoteDetail: function (data) {

      this.isShowQuoteInfo = true;
      // ONE ordered list → QuoteInfo/ActionBar: 3 pills, the rest in ⋮.
      // primary (status action) is moved first; 'danger' (Pause Job, Cancel Quote) goes last.
      this.actionButtons = [];
      this.isQrEnabled = false
      // Figma "Quote Details - Option 1": Edit Quote (red) then Waive TradeCall Fee (blue), View Quote after them
      if (data.status.technician.status == 0) {
        if (data.is_quote_submitted == 1) {
          this.actionButtons.push({ title: 'Checkout', image: 'checkout.png', color: '#2563EB', primary: true });
        }
        this.actionButtons.push({ title: 'Edit Quote', image: 'edit-quote.png', color: '#F67280' });
        if (data.partner_info.is_allied == "1") {
          this.getReasonsCall();
        }
      } else if (data.status.technician.status == 1) {
        // Android enrouteState
        this.actionButtons.push({ title: 'Arrived', image: 'start-quote.png', color: '#F67280', primary: true });
      } else if (data.status.technician.status == 2) {
        this.actionButtons.push({ title: 'Start Job', image: 'start-quote.png', color: '#F67280', primary: true });
        this.actionButtons.push({ title: 'Pause Job', image: 'pause-job.png', color: '#F59E0B', variant: 'danger' });
      } else if (data.status.technician.status == 6) {
        this.actionButtons.push({ title: 'Resume Job', image: 'resume-job.png', color: '#06B6D4', primary: true });
      } else if (data.status.technician.status == 7) {
        this.actionButtons.push({ title: 'Complete Job', image: 'complete-job.png', color: '#16A34A', primary: true });
        this.actionButtons.push({ title: 'Pause Job', image: 'pause-job.png', color: '#F59E0B', variant: 'danger' });
      } else if (data.status.technician.status == 3) {
        this.checkoutAcknowledge({
          manual_quote_id: this.$route.params.id,
          decision: "yes",
        });
      } else if (data.status.technician.status == 4) {
        this.startQuote({
          manual_quote_id: this.$route.params.id,
        });
      }
      // this.actionButtons.push({ title: 'Internal Notes', image: 'internal-notes.png' });

      if (data.waive_trade_call_fee_button == 1) {
        this.actionButtons.push({ title: 'Waive TradeCall Fee', image: 'waive-tradecall-fee.png', color: '#7695FF' });
      }

      // Android IndependentQuoteDetailFragment: every state offers View Quote; only Pending (0) waits for items
      if (data.status.technician.status != 0 || data.items?.length > 0) {
        this.actionButtons.push({ title: 'View Quote', image: 'view-quote.png', color: '#6366F1' });
      }

      if (data.is_quote_submitted == 1) {
        this.actionButtons.push({ title: 'Share Quote', image: 'share-quote.png', color: '#7C3AED' });
        this.isQrEnabled = true
      }

      // Android setViewDetailButton: open the source the quote came from
      const source = SOURCE_ACTIONS[String(data.job_source?.slug || '').toLowerCase()];
      if (source && Number(data.job_source?.id) > 0) {
        this.actionButtons.push({ title: source.title, image: '', color: '#7695FF' });
      }

      // Android pendingState: an allied partner quote can be cancelled once submitted, any other quote always
      if (data.status.technician.status == 0 && (data.partner_info?.is_allied != "1" || data.is_quote_submitted == 1)) {
        this.actionButtons.push({ title: 'Cancel Quote', image: 'cancel-quote.png', color: '#DC2626', variant: 'danger' });
      }

    },

    quoteSummary: function (data) {
      this.summary = data;
      this.modal = new Modal(this.$refs.modal);
      this.modal.show();
      disableScroll()
    },

    checkoutResponse: function () {
      this.getQuoteDetail({
        manual_quote_id: this.$route.params.id,
      });
    },

    createInvoiceResponse: function () {
      this.$router.push({
        path: `/checkout/invoice/${this.createInvoiceResponse.invoice_id}`
      });
    },


  },

  mounted() {

    this.timer = setInterval(() => {
      this.getQuoteDetail({
        manual_quote_id: this.$route.params.id,
        is_hide: true,
      });
    }, 45000);

    this.getQuoteDetail({
      manual_quote_id: this.$route.params.id,
    });
    if (this.$route.query.is_edit == 1) {
      localStorage.setItem(this.$route.params.id + "-quote", null);
      this.$router.push({
        path: `/quote/edit/${this.$route.params.id}`,
        query: {
          is_edit: 1,
        },
      });
    }
  },

  beforeRouteLeave() {
    clearInterval(this.timer);
  },

  methods: {
    ...mapActions([
      "sendQuoteToEmail",
      "setCommponent",
      "getQuoteDetail",
      "postCancelQuote",
      "postDeclineQuote",
      "getQuoteSummary",
      "startQuote",
      "pauseQuote",
      "completeQuote",
      "checkoutAcknowledge",
      "getReasons",
      "waiveTradeCall",
      "resubmitManualQuote",
      "createInvoice",
    ]),


    checkNoteAlert() {
      if (this.quoteDetail &&
        this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.show_replacement_opportunity_badge == '1'
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.company_name != 'Vivint'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
        return true
      } else {
        return false
      }
    },

    onSubmit() {
      if (this.isValid()) {
        this.sendQuoteToEmail({
          manual_quote_id: this.$route.params.id,
          email: this.email.trim(),
          phone: this.phone,
        });
      }
    },

    getReasonsCall() {
      this.getReasons({
        id: this.$route.params.id
      });
    },

    isValid() {
      var status = true;

      if (this.email.length <= 0 && this.phone.length <= 0) {
        toast.error(
          "Please enter the email address or phone number below to send quote."
        );
        status = false;
      } else {
        if (!this.validateEmail() && this.email.length > 0) {
          toast.error("Email address not valid.");
          status = false;
        }

        if (this.phone.length < 14 && this.phone.length > 0) {
          toast.error("Phone number not valid.");
          status = false;
        }
      }

      return status;
    },

    validateEmail() {
      var regex = this.$constants.EMAIL_REGEX;
      return regex.test(this.email);
    },
    acceptNumber() {
      var x = this.phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },

    CancelCallback(opt, data) {
      if (opt == "close") {
        enableScroll()
        this.modal.hide();
      } else if (opt == "confirm") {
        data.manual_quote_id = this.$route.params.id;
        enableScroll()
        this.modal.hide();
        if (this.quoteDetail.partner_info.negative_action == 'decline') {
          this.postDeclineQuote(data);
        } else {
          this.postCancelQuote(data);
        }
      }
    },


    waiveTradeCallFeeClicked() {
      disableScroll()
      this.modal = new Modal(this.$refs.waiveTradeCallFee);
      this.modal.show();
    },
    closeWaiveTradeCallFee() {
      enableScroll()
      this.modal.hide();
    },
    continueWaiveTradeCallFee() {
      this.closeWaiveTradeCallFee();
      this.waiveTradeCall({
        manual_quote_id: this.$route.params.id,
      });
    },
    actionButtonClicked(action) {
      const source = Object.values(SOURCE_ACTIONS).find(a => a.title === action);
      if (source) {
        // from_detail: the appointment opens its own detail instead of jumping to its converted job (this quote)
        this.$router.push({
          path: source.path + this.quoteDetail.job_source.id,
          query: source === SOURCE_ACTIONS.appointment ? { from_detail: 1 } : {},
        });
        return;
      }
      if (action == "Arrived") {
        this.$dialog.show({
          title: "Arrived",
          text: "Are you sure you have arrived at consumer's location?",
          buttonText: "Yes",
          onConfirm: async () => {
            const res = await uqApi.arrived(this.$route.params.id);
            if (!res.ok) return toast.error(res.message || "Unable to update the status.");
            toast.success(res.message || "Status updated.");
            this.getQuoteDetail({ manual_quote_id: this.$route.params.id });
          },
        });
        return;
      }
      // normal quote: change trade / service / job / property / payment / unit first (Android UQConfigFragment)
      if (action == "Edit Quote" && !this.isPartnerQuote) {
        this.updatingQuote = true;
        disableScroll();
        Modal.getOrCreateInstance(this.$refs.uqUpdateModal, { backdrop: "static", keyboard: false }).show();
        return;
      }
      if (action == "Edit Quote") {
        localStorage.setItem(this.$route.params.id + "-quote", null);
        this.$router.push({
          path: `/quote/edit/${this.$route.params.id}`,
        });
      } else if (action == "View Quote") {
        var params = {
          manual_quote_id: this.quoteDetail.id,
        };
        params["status"] = "submitted";

        if (this.isPartnerQuote) {
          this.getQuoteSummary({
            url: "/manual-quote/partner/summary",
            params: params
          });
        } else {
          this.getQuoteSummary({
            url: "/manual-quote/summary/calculate",
            params: params
          });
        }
      } else if (action == "Cancel Quote") {
        if (this.quoteDetail.partner_info.is_allied == "1") {
          this.modal = new Modal(this.$refs.cancelQuoteI);
          this.modal.show();
          disableScroll()
        } else {
          this.modal = new Modal(this.$refs.cancelQuote);
          this.modal.show();
          disableScroll()
        }
      } else if (action == "Start Job") {
        this.startQuote({
          manual_quote_id: this.$route.params.id,
        });
      } else if (action == "Resume Job") {
        this.$dialog.show({
          title: "Resume Job",
          text: "Are you sure you want to resume this job?",
          buttonText: "Confirm",
          onConfirm: () => this.startQuote({ manual_quote_id: this.$route.params.id }),
        });
      } else if (action == "Pause Job") {
        // confirm first (same popup as Sign Out)
        this.$dialog.show({
          title: "Pause Job",
          text: "Are you sure you want to pause this job?",
          buttonText: "Confirm",
          onConfirm: () => this.pauseQuote({ manual_quote_id: this.$route.params.id }),
        });
      } else if (action == "Complete Job") {
        this.$dialog.show({
          title: "Complete Job",
          text: "Are you sure you want to complete this job?",
          buttonText: "Confirm",
          onConfirm: () => this.completeQuote({ manual_quote_id: this.$route.params.id }),
        });
      } else if (action == "Share Quote") {

        this.email = this.quoteDetail.consumer.email ?? ""
        this.phone = this.quoteDetail.consumer.phone ?? ""

        this.modal = new Modal(this.$refs.shareQuote);
        this.modal.show();
        disableScroll()
      } else if (action == "Waive TradeCall Fee") {
        this.waiveTradeCallFeeClicked()
      } else if (action == "Checkout") {
        this.createInvoice({
          job_id: this.$route.params.id,
          job_type: 'mq'
        });
      } else if (action == "Internal Notes") {
        this.openNotesModal()
      }

    },

    closeUpdateModal() {
      Modal.getInstance(this.$refs.uqUpdateModal)?.hide();
      enableScroll();
      this.updatingQuote = false;
    },
    // Android: "Universal Quote Updated Successfully." then the quote editor
    quoteUpdated() {
      this.closeUpdateModal();
      localStorage.setItem(this.$route.params.id + "-quote", null);
      this.$router.push({ path: `/quote/edit/${this.$route.params.id}` });
    },
    openNotesModal() {
      disableScroll()
      this.isNotesOpen = true;
    },
    closeNotesModal() {
      enableScroll()
      this.isNotesOpen = false;
    },

    closeModal() {
      enableScroll()
      this.modal.hide();
    },
  },
};
</script>

<style>
.primaryBtn {
  background: #fe5000 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 5px #999 !important;
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
}

.secondaryBtn {
  background: #003087 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 5px #999 !important;
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
}

.shareModal .modal-header {
  background: #003087;
  text-align: center;
  color: #fff;
  justify-content: space-between;
  display: block;
}


.btn-close-Pop {
  background: none;
  border: 0;
  position: absolute;
  top: 15px;
  right: 10px;
}


.actionQouteBtn {
  text-align: center;
}

.actionQouteBtn h3 {
  color: #003087;
  margin-bottom: 25px;
  border-bottom: 2px solid #00308726;
  padding-bottom: 15px;
  text-align: left;
}

@media screen and (max-width: 992px) {
  .actionQouteBtn .btn-group button {
    margin-bottom: 0.5rem;
    font-size: 16px;
    padding: 0.5rem 1.2rem;
  }
}

@media screen and (max-width: 575px) {
  .actionQouteBtn .btn-group button {
    margin-bottom: 0.5rem;
    font-size: 15px;
    padding: 0.5rem 1rem;
  }
}
</style>
